export const decodeJWT = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const payload = JSON.parse(window.atob(base64Url));
    const { exp, iat, nbf, ...data } = payload;

    return data;
  } catch {
    return null;
  }
}